import { render } from "./SelectDnTService.vue?vue&type=template&id=0a13a652&scoped=true"
import script from "./SelectDnTService.vue?vue&type=script&lang=js"
export * from "./SelectDnTService.vue?vue&type=script&lang=js"

import "./SelectDnTService.vue?vue&type=style&index=0&id=0a13a652&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a13a652"]])

export default __exports__